'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultUtms = require('./defaultUtms');

var _defaultUtms2 = _interopRequireDefault(_defaultUtms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expUtms = {};
_defaultUtms2.default.forEach(function (utmKey) {
  // looks like `exp-campaign`
  var expKey = utmKey.replace('utm_', 'exp-');
  expUtms[expKey] = utmKey;
});

exports.default = expUtms;
module.exports = exports['default'];